"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalServerError = void 0;
const ResponseError_1 = require("./ResponseError");
class InternalServerError extends ResponseError_1.ResponseError {
    constructor(message = "Internal server error.") {
        super("Internal server error.", message, 500);
    }
}
exports.InternalServerError = InternalServerError;
//# sourceMappingURL=InternalServerError.js.map